import map from "lodash/map";

import { FileDownloadLink } from "./file-download-link";
import { ResultDetail } from "./result-detail";
import { ResultsSection } from "./results-section";
import { QuestionType } from "@/types/screener-builder/questions";
import { S3_URI_PREFIX } from "@/constants/s3";
import { CompetencyFit, type Screening } from "@/types/screeners";

interface KeyAnswersProps {
  screening: Screening;
}

export const KeyAnswers = ({
  screening: {
    candidateName,
    createdAt,
    jobTitle,
    sessionId,
    showInSummary,
    showInSummaryMeta,
  },
}: KeyAnswersProps) => {
  // Santi review: Key Answers should never include a "PLAY VOICE ANSWER"
  // link — recording playback only belongs in the competency section
  // beside the relevant quote. Previously this block extracted the first
  // candidate voice message and rendered a `<VoiceAnswerLink>` below the
  // key answers, which was a duplicate entry point for the same recording.
  // The section now only renders the `show_in_summary` key/value rows.
  if (!showInSummary || Object.keys(showInSummary).length === 0) {
    return null;
  }

  return (
    <ResultsSection title="Key answers">
      {map(showInSummary, (value, key) => {
        if (value === CompetencyFit.NotAsked) {
          return <ResultDetail key={key} label={key} value={String(value)} />;
        }

        const meta = showInSummaryMeta?.[key];

        if (
          meta?.inputType === QuestionType.FileUpload &&
          meta.questionRootId &&
          String(value).startsWith(S3_URI_PREFIX)
        ) {
          return (
            <ResultDetail
              key={key}
              label={key}
              value={
                <FileDownloadLink
                  candidateName={candidateName}
                  createdAt={createdAt}
                  internalLabel={key}
                  jobTitle={jobTitle}
                  questionRootId={meta.questionRootId}
                  s3Uri={String(value)}
                  sessionId={sessionId}
                />
              }
            />
          );
        }

        return <ResultDetail key={key} label={key} value={String(value)} />;
      })}
    </ResultsSection>
  );
};
